























import { log } from '@/log'
import { sortOptions, SortType } from '@hl-itemlist/model/condition'
import Vue, { PropType } from 'vue'

/**
 * 一覧の並び順を選択するプルダウン(列数切替ColumnCountSwitcherと同じ見せ方)。
 * 選択肢と語彙はconditionモデルのsortOptionsが正。選択はvalueで受け取りinputで返すだけで、状態は持たない。
 */
export default Vue.extend({
  props: {
    value: {
      type: String as PropType<SortType>,
      required: true,
    },
  },
  data() {
    return {
      options: sortOptions,
    }
  },
  methods: {
    onChange(value: string): void {
      // selectのvalueは素の文字列のため、sortOptionsの語彙にあるものだけを親へ返す
      const matched = sortOptions.find(option => option.value === value)
      if (matched) {
        this.$emit('input', matched.value)
      } else {
        // 選択肢はoptionsに限られるためここには来ないはず。来たら内部実装のミス(option定義の誤り等)
        log.warn(`hl-itemlist: unknown sort value: ${value}`)
      }
    },
  },
})
